import { render } from "./index.vue?vue&type=template&id=f93d612c&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Pages/Admin/Players/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f93d612c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f93d612c', __exports__)) {
    api.reload('f93d612c', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=f93d612c&ts=true", () => {
    api.rerender('f93d612c', render)
  })

}


export default __exports__